import { defineComponent, ref, watch, computed, nextTick } from "vue";
import PointDialog from "./dialog.vue";
import PointList from "./list.vue";
import _ from "lodash";
import { t } from "@/lang";
export default defineComponent({
    components: {
        PointDialog: PointDialog,
        PointList: PointList
    },
    props: {
        actions: {
            type: Object
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var dialogVisible = ref(false);
        var btnLabel = t("playTurbo.whole.plPoint.list.title");
        var pointDialogRef = ref();
        var trigger = ref();
        var handleClick = function() {
            dialogVisible.value = !dialogVisible.value;
        };
        var sendPointList = ref([]);
        var pointEvent = "PLAYABLE:SENDPOINT" // 预览埋点事件
        ;
        window.addEventListener("message", function(event) {
            if (event.data === "scene-game-ready") {
                var iframe = document.querySelector("iframe");
                // 获取iframe发送埋点方法
                var sendPoint = _.get(iframe, "contentWindow.HttpAPI.sendPoint");
                if (sendPoint) sendPoint("ir");
            }
            if (event.data.type === pointEvent) {
                var pointName = event.data.data.pointName;
                if (pointName === "pv") {
                    sendPointList.value = [];
                }
                sendPointList.value.push({
                    name: pointName
                });
            }
        }, false);
        watch(function() {
            return dialogVisible.value;
        }, function(val) {
            if (val && pointDialogRef.value) {
                nextTick(function() {
                    if (pointDialogRef.value && trigger.value) {
                        var domEl = pointDialogRef.value.$el;
                        var triggerEl = trigger.value.$el;
                        var dialog = domEl.querySelector(".el-dialog");
                        var position = triggerEl.getBoundingClientRect();
                        if (dialog) {
                            dialog.style.top = "".concat(position.top + position.height + 5, "px");
                            dialog.style.left = "".concat(position.left + position.width - dialog.getBoundingClientRect().width, "px");
                        }
                    }
                });
            }
        });
        var innerPointList = computed(function() {
            return sendPointList.value.filter(function(item) {
                return [
                    "pv",
                    "ir",
                    "ws"
                ].every(function(key) {
                    return item.name !== key;
                });
            });
        });
        return {
            btnLabel: btnLabel,
            dialogVisible: dialogVisible,
            handleClick: handleClick,
            sendPointList: sendPointList,
            pointDialogRef: pointDialogRef,
            innerPointList: innerPointList,
            trigger: trigger
        };
    }
});
